//All Api should be done in Higher component all the renders should be done in child
import React, { useContext, useEffect, useState } from "react";

//@MUI
import {
  Divider,
  Grid,
  Modal,
  Paper,
  Snackbar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";

//components
import PropTypes from "prop-types";
import NoData from "../../../Pages/InformativeComponents/NoData.component";
import ManageUsersModal from "../../Utilities/ManageUsers/ManageUsersModal/ManageUsersModal.component.jsx";
import ProjectCards from "../ProjectPageCards/ProjectCards.component";
import ListView from "../ProjectPageListView/ProjectListView.component";
import ProjectPageNewProjectModal from "../ProjectPageModals/ProjectPageNewProjectModal";
import ProjectTools from "../ProjectPageTools/ProjectPageTools.component.jsx";
//css
import { Alert } from "@material-ui/lab";
import { ErrorBoundary } from "@sentry/react";
import { fdelete, fget, fpatch, fpost } from "../../../API/callsAPI";
import { MovieColabContext } from "../../../Context/MovieColabContext";
import CustomPagination from "../../Utilities/CustomPagination/CustomPagination.component";
import DeleteModal from "../../Utilities/DeleteModal/DeleteModal.component";
import PageBreakError from "../../Utilities/ErrorFalbackComponents/PageBreakError";
import ErrorOrSuccessMessage from "../../Utilities/ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";
import CustomLoader from "../../Utilities/Loader/CustomLoader.jsx";
import NewDataLoadingLoader from "../../Utilities/NewDataLoadingLoader/NewDataLoadingLoader.component";
import CreateOrEditTeamModal from "../ProjectPageModals/CreateOrEditTeamModal/CreateOrEditTeamModal.jsx";
import ManageCollaboratorModal from "../ProjectPageModals/ManageCollaboratorModal/ManageCollaboratorModal.jsx";
import useStyles from "./ProjectPageOverview.styles";

function ProjectsPageOverview({
  //general props
  projectItems, //project
  projectView, //current view active or archived
  handleProjectView, //change current view
  isLoaded, //loader state
  updateRefreshToken,
  handlePageChange, //change projects page
  //props for active projects
  totalActiveProjectCount, //to show total page in pagination
  currentActiveProjectPage, //current page number
  setIsNewActiveProjectsLoading, //to set loader of new page loading
  isNewActiveProjectsLoading, //to set loader that new page loading
  //props for archived projects
  totalArchivedProject, //to show total page in pagination
  archivedProjectPageNo, //current page number
  setIsNewArchivedPageLoading, //to set loader of new page loading
  isNewArchivedPageLoading, //to set loader that new page loading
  onProjectSelect,
  setSelectedTeam,
  selectedTeam,
}) {
  const { loggedInUser } = useContext(MovieColabContext);
  const classes = useStyles();
  const [isCardView, setIsCardView] = useState(true);
  const [isFilterModalOpen, setFilterModalOpen] = useState(false);
  const [isSortModalOpen, setSortModalOpen] = useState(false);
  const [isNewProjModalOpen, setNewProjModalOpen] = useState(false);
  const [sortByDefault, setSortByDefault] = useState("LatestModified");
  const [projectMirage, setProjectMirage] = useState(projectItems);
  const [pinnedProjects, setPinnedProjects] = useState([]);
  const disableFilter = true;
  const [manageUserModal, setManageUserModal] = useState({
    modalOpen: false,
    projectId: 0,
  });
  const [snackValue, setSnackValue] = React.useState({
    isOpen: false,
    message: "",
    isError: false,
  });
  const [orgUsers, setOrgUsers] = useState([]);
  const [projectUsers, setProjectUsers] = useState([]);
  const [projectUsersOriginal, setProjectUsersOriginal] = useState([]);
  const [projectAdmin, setProjectAdmin] = useState([]);
  const [projectAdminOriginal, setProjectAdminOriginal] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isTasksTogglerOn, setIsTasksTogglerOn] = useState(false);
  const [editProjectModalData, setEditProjectModalData] = useState({
    isOpen: false,
    selectedProject: {},
  });
  const [deleteProjectModalData, setDeleteProjectModalData] = useState({
    isOpen: false,
    selectedProject: {},
  });
  const [manageCollaboratorModalData, setManageCollaboratorModalData] =
    useState({
      isOpen: false,
      selectedProject: {},
    });
  const [isCreateTeamModalOpen, setIsCreateTeamModalOpen] = useState(false);
  const [myTeams, setMyTeams] = useState([]);
  const [refreshCounter, setRefreshCounter] = useState(0);

  useEffect(() => {
    setProjectMirage(projectItems);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectView, projectItems, archivedProjectPageNo]);

  useEffect(() => {
    setProjectMirage(projectItems);
    const storedPinnedProjects = JSON.parse(
      localStorage.getItem("pinnedProjects") || "[]",
    );
    setPinnedProjects(storedPinnedProjects);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (manageUserModal.projectId) {
      defaultUsers();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manageUserModal.projectId]);

  function handleViewToggle() {
    if (isCardView) setIsCardView(false);
    else setIsCardView(true);
  }

  function handleFilterModalState() {
    setFilterModalOpen(!isFilterModalOpen);
  }

  function handleSortModalState() {
    setSortModalOpen(!isSortModalOpen);
  }

  function handleNewProjModalState() {
    setNewProjModalOpen(!isNewProjModalOpen);
  }

  const handleEditProjectModal = (project) => {
    setEditProjectModalData({
      isOpen: true,
      selectedProject: project,
    });
  };

  const handleDeleteProjectModal = (project) => {
    setDeleteProjectModalData({ isOpen: true, selectedProject: project });
  };

  const handleTasksToggler = () => {
    setIsTasksTogglerOn(!isTasksTogglerOn);
  };

  const defaultUsers = async () => {
    if (manageUserModal.projectId) {
      let selectedProject = await projectItems?.filter((el) => {
        return el.id === manageUserModal.projectId;
      });
      let usersAlready =
        orgUsers &&
        orgUsers.filter((el) => selectedProject[0].users.includes(el.value));
      let adminAlready =
        orgUsers &&
        orgUsers.filter((el) =>
          selectedProject[0].admin_users.includes(el.value),
        );
      setProjectAdmin(adminAlready);
      setProjectUsers(usersAlready);
      setProjectUsersOriginal(usersAlready);
      setProjectAdminOriginal(adminAlready);
    } else {
      return;
    }
  };

  const addUsers = async (addedAdmins, addedUsers) => {
    const manageUserData = {
      url: `project/${manageUserModal.projectId}/add_user/`,
      data: {
        users: [...addedAdmins, ...addedUsers],
      },
    };
    try {
      const res = await fpost(manageUserData);
      setIsUpdating(false);
      setSnackValue({
        isOpen: true,
        message: `SuccessFully updated user for "${res?.data?.name}"`,
        isError: false,
      });
      updateRefreshToken();
      setManageUserModal({ modalOpen: false, projectId: 0 });
    } catch (error) {
      setIsUpdating(false);
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  const removeUsers = async (removedUsers, removedAdmins) => {
    const manageUserData = {
      url: `project/${manageUserModal.projectId}/remove_user/`,
      data: {
        users: [...removedAdmins, ...removedUsers],
      },
    };
    try {
      const res = await fpost(manageUserData);
      setIsUpdating(false);
      setSnackValue({
        isOpen: true,
        message: `SuccessFully updated user for "${res?.data?.name}"`,
        isError: false,
      });
      updateRefreshToken();
      setManageUserModal({ modalOpen: false, projectId: 0 });
    } catch (error) {
      setIsUpdating(false);
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  const submitManageUsersChanges = async (event) => {
    event.preventDefault();
    const addedAdmins = projectAdmin
      .filter(
        (user) =>
          !projectAdminOriginal.some((orgUser) => orgUser.value === user.value),
      )
      .map((user) => {
        return {
          user_id: user.value,
          role: "admin",
        };
      });
    const removedAdmins = projectAdminOriginal
      .filter((user) => !projectAdmin.some((curr) => curr.value === user.value))
      .map((user) => {
        return {
          user_id: user.value,
        };
      });
    const addedUsers = projectUsers
      .filter(
        (user) =>
          !projectUsersOriginal.some((orgUser) => orgUser.value === user.value),
      )
      .map((user) => {
        return {
          user_id: user.value,
          role: "user",
        };
      });
    const removedUsers = projectUsersOriginal
      .filter((user) => !projectUsers.some((curr) => curr.value === user.value))
      .map((user) => {
        return {
          user_id: user.value,
        };
      });
    if (
      addedUsers.length > 0 ||
      addedAdmins.length > 0 ||
      removedUsers.length > 0 ||
      removedAdmins.length > 0
    ) {
      setIsUpdating(true);
    }
    if (addedUsers.length > 0 || addedAdmins.length > 0) {
      addUsers(addedAdmins, addedUsers);
    }
    if (removedUsers.length > 0 || removedAdmins.length > 0) {
      removeUsers(removedUsers, removedAdmins);
    }
  };

  const handleSelectAdmin = (admins) => {
    setProjectAdmin(admins);
  };
  const handleSelectUser = (users) => {
    setProjectUsers(users);
  };

  function handleFilterBy(start, end) {
    var startDate = new Date(start);
    var endDate = new Date(end);

    var filteredProject = projectItems.filter((a) => {
      var date = new Date(a.created_at);
      return date >= startDate && date <= endDate;
    });

    setProjectMirage(filteredProject);
  }

  function handleSubmitSort(sortBy) {
    setSortModalOpen(false);

    switch (sortBy) {
      case "LatestModified":
        projectMirage.sort(function (a, b) {
          var dateA = new Date(a.updated_at),
            dateB = new Date(b.updated_at);
          return dateB - dateA;
        });
        setSortByDefault("LatestModified");
        break;
      case "A-Z":
        projectMirage.sort((a, b) => a.name.localeCompare(b.name));
        setSortByDefault("A-Z");
        break;
      case "Z-A":
        projectMirage.sort((a, b) => b.name.localeCompare(a.name));
        setSortByDefault("Z-A");
        break;
      case "LastModified":
        projectMirage.sort(function (a, b) {
          var dateA = new Date(a.updated_at),
            dateB = new Date(b.updated_at);
          return dateA - dateB;
        });
        setSortByDefault("LastModified");
        break;
      case "DateCreated":
        projectMirage.sort(function (a, b) {
          var dateA = new Date(a.created_at),
            dateB = new Date(b.created_at);
          return dateA - dateB;
        });
        setSortByDefault("DateCreated");
        break;
      default:
        return projectItems;
    }
  }

  const handleDeleteProject = async () => {
    try {
      await fdelete({
        url: `project/${deleteProjectModalData?.selectedProject?.id}/`,
      });
      setSnackValue({
        isOpen: true,
        message: `SuccessFully deleted "${deleteProjectModalData?.selectedProject?.name}"`,
        isError: false,
      });
      updateRefreshToken();
      setDeleteProjectModalData({ isOpen: false, selectedProject: {} });
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  const sortProjectByPinned = () => {
    const sortedProject = [...projectItems].sort((a, b) => {
      const aIndex = pinnedProjects.indexOf(a.id);
      const bIndex = pinnedProjects.indexOf(b.id);
      if (aIndex !== -1 && bIndex === -1) {
        return -1;
      }
      if (aIndex === -1 && bIndex !== -1) {
        return 1;
      }
      return 0;
    });
    setProjectMirage(sortedProject);
  };

  useEffect(() => {
    sortProjectByPinned();
  }, [projectItems]);

  useEffect(() => {
    localStorage.setItem("pinnedProjects", JSON.stringify(pinnedProjects));
    sortProjectByPinned();
  }, [pinnedProjects]);

  const handleunPinnedPost = (id) => {
    const newPinnedProj = pinnedProjects.filter((eachId) => eachId !== id);
    setPinnedProjects(newPinnedProj);
  };

  const handlePinnedPost = (id) => {
    setPinnedProjects([...pinnedProjects, id]);
  };

  const handleArchiveProject = async (project) => {
    const editProject = {
      url: `project/${project.id}/`,
      data: {
        archived_by:
          project?.archived_by?.length > 0
            ? [...project?.archived_by, loggedInUser?.id]
            : [loggedInUser?.id],
      },
    };
    try {
      const archiveProjectRes = await fpatch(editProject);
      if (archiveProjectRes.status === 200 || 201) {
        setSnackValue({
          isOpen: true,
          message: `SuccessFully Archived "${archiveProjectRes?.data?.name}"`,
          isError: false,
        });
        updateRefreshToken();
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };
  const handleUnArchiveProject = async (project) => {
    const editProject = {
      url: `project/${project.id}/`,
      data: {
        archived_by: project?.archived_by?.filter(
          (arc) => arc !== loggedInUser?.id,
        ),
      },
    };
    try {
      const archiveProjectRes = await fpatch(editProject);
      if (archiveProjectRes.status === 200 || 201) {
        setSnackValue({
          isOpen: true,
          message: `SuccessFully UnArchived "${archiveProjectRes?.data?.name}"`,
          isError: false,
        });
        updateRefreshToken();
      }
    } catch (error) {
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  function handleProjectSelect(projectObject) {
    onProjectSelect(projectObject);
  }

  useEffect(() => {
    const handleGetTeams = async () => {
      try {
        const res = await fget({ url: "project-space/" });
        setMyTeams(res?.data?.results);
      } catch (error) {
        console.log(error);
      }
    };
    handleGetTeams();
  }, [refreshCounter]);

  return (
    <div style={{ padding: "0% 1.6%", height: "70%" }}>
      {isUpdating ? (
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          open={true}
        >
          <Alert severity="info">Updating Please Wait</Alert>
        </Snackbar>
      ) : (
        <ErrorOrSuccessMessage snackValue={snackValue} />
      )}
      <ProjectTools
        toggleCardView={handleViewToggle}
        openFilterModal={handleFilterModalState}
        openSortModal={handleSortModalState}
        openNewProjModal={handleNewProjModalState}
        isCardView={isCardView}
        handleTasksToggler={handleTasksToggler}
        handleFilter={(selectedStartDate, selectedEndDate) =>
          handleFilterBy(selectedStartDate, selectedEndDate)
        }
        value={projectMirage}
        updateRefreshToken={updateRefreshToken}
        onSubmit={handleSubmitSort}
        defaultvalue={sortByDefault}
        handleProjectView={handleProjectView}
        projectView={projectView}
        handleOpenCreateTeamModal={() => setIsCreateTeamModalOpen(true)}
        myTeams={myTeams}
        setSelectedTeam={setSelectedTeam}
        selectedTeam={selectedTeam}
        projectCount={projectItems?.length}
      />

      {!isLoaded ? (
        <CustomLoader />
      ) : (
        <ErrorBoundary
          fallback={({ error, componentStack, resetError }) => (
            <PageBreakError
              error={error}
              resetError={resetError}
              componentStack={componentStack}
            />
          )}
          beforeCapture={(scope) => {
            scope.setTag("location", "Project Page");
            // scope.setTag("version", selectedVersion);
          }}
        >
          <div className={classes.projectPageCardsDiv1}>
            {isCardView ? (
              <>
                {projectMirage && projectMirage.length !== 0 ? (
                  <Grid
                    container
                    spacing={5}
                    justify="between"
                    style={{
                      maxHeight:
                        totalActiveProjectCount > 50 ||
                        totalArchivedProject > 50
                          ? `calc(100vh - 215px)`
                          : `calc(100vh - 200px)`,
                      overflow: "auto",
                      paddingRight: "0.9%",
                    }}
                  >
                    {projectMirage?.map((project) => {
                      return (
                        <Grid
                          xs={12}
                          sm={6}
                          lg={4}
                          xl={3}
                          item
                          key={project.id}
                        >
                          <ProjectCards
                            project={project}
                            handleManageUserModal={(value) =>
                              setManageUserModal(value)
                            }
                            updateRefreshToken={updateRefreshToken}
                            setSnackValue={setSnackValue}
                            usersList={orgUsers}
                            handlePinnedPost={handlePinnedPost}
                            pinnedProjects={pinnedProjects}
                            handleunPinnedPost={handleunPinnedPost}
                            handleEditProjectModal={handleEditProjectModal}
                            handleDeleteProjectModal={handleDeleteProjectModal}
                            handleArchiveProject={handleArchiveProject}
                            handleUnArchiveProject={handleUnArchiveProject}
                            loggedInUser={loggedInUser}
                            handleProjectSelect={onProjectSelect}
                            handleManageCollaboratorModal={() =>
                              setManageCollaboratorModalData({
                                isOpen: true,
                                selectedProject: project,
                              })
                            }
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                ) : (
                  <NoData />
                )}
              </>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <Divider flexItem className={classes.divider} />
                {projectMirage && projectMirage.length !== 0 ? (
                  <TableContainer
                    component={Paper}
                    className={classes.tableContainer}
                  >
                    <Table
                      stickyHeader
                      className={classes.table}
                      aria-label="simple table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell
                            className={classes.headTable}
                            style={{ width: "20%" }}
                          >
                            Project Name
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.headTable}
                            style={{ width: "15%" }}
                          >
                            User Role
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.headTable}
                            style={{ width: "15%" }}
                          >
                            Date Created
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.headTable}
                            style={{ width: "25%" }}
                          >
                            Description
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.headTable}
                            style={{ width: "15%" }}
                          >
                            Last Modified
                          </TableCell>
                          <TableCell
                            align="left"
                            className={classes.headTable}
                            style={{ width: "10%" }}
                          >
                            Users
                          </TableCell>
                          <TableCell
                            align="right"
                            className={classes.headTable}
                            style={{ width: "10%" }}
                          >
                            Action
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {!disableFilter
                          ? projectMirage &&
                            projectMirage.length &&
                            projectMirage?.map((project) => {
                              return (
                                <ListView
                                  key={project?.id}
                                  project={project}
                                  isTasksTogglerOn={isTasksTogglerOn}
                                  allUserList={[]}
                                  handleManageUserModal={(value) =>
                                    setManageUserModal(value)
                                  }
                                  updateRefreshToken={updateRefreshToken}
                                  setSnackValue={setSnackValue}
                                  handleEditProjectModal={
                                    handleEditProjectModal
                                  }
                                  handleDeleteProjectModal={
                                    handleDeleteProjectModal
                                  }
                                  handleArchiveProject={handleArchiveProject}
                                  handleUnArchiveProject={
                                    handleUnArchiveProject
                                  }
                                  loggedInUser={loggedInUser}
                                  handleProjectSelect={onProjectSelect}
                                />
                              );
                            })
                          : projectMirage &&
                            projectMirage.length &&
                            projectMirage?.map((project) => {
                              return (
                                <ListView
                                  key={project?.id}
                                  project={project}
                                  isTasksTogglerOn={isTasksTogglerOn}
                                  allUserList={[]}
                                  handleManageUserModal={(value) =>
                                    setManageUserModal(value)
                                  }
                                  updateRefreshToken={updateRefreshToken}
                                  setSnackValue={setSnackValue}
                                  handleEditProjectModal={
                                    handleEditProjectModal
                                  }
                                  handleDeleteProjectModal={
                                    handleDeleteProjectModal
                                  }
                                  handleArchiveProject={handleArchiveProject}
                                  handleUnArchiveProject={
                                    handleUnArchiveProject
                                  }
                                  loggedInUser={loggedInUser}
                                  handleProjectSelect={onProjectSelect}
                                />
                              );
                            })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                ) : (
                  <NoData />
                )}
              </div>
            )}
          </div>
        </ErrorBoundary>
      )}
      <div>
        {projectView === "active" ? (
          <>
            {totalActiveProjectCount > 50 ? (
              <CustomPagination
                handlePageChange={handlePageChange}
                currentPage={currentActiveProjectPage}
                totalItem={totalActiveProjectCount}
                totalPage={Math.ceil(totalActiveProjectCount / 50)}
                setIsNewPageLoading={setIsNewActiveProjectsLoading}
                trackable="Active Projects"
              />
            ) : (
              ""
            )}
          </>
        ) : (
          <>
            {totalArchivedProject > 50 ? (
              <CustomPagination
                handlePageChange={handlePageChange}
                currentPage={archivedProjectPageNo}
                totalItem={totalArchivedProject}
                totalPage={Math.ceil(totalArchivedProject / 50)}
                setIsNewPageLoading={setIsNewArchivedPageLoading}
                trackable="Archived Projects"
              />
            ) : (
              ""
            )}
          </>
        )}
      </div>

      <div>
        {/* <Modal
          open={isFilterModalOpen}
          onClose={() => setFilterModalOpen(false)}
          className={classes.projectPageModals}
        >
          <ProjectPageFiltersModal
            handleFilter={(selectedStartDate, selectedEndDate) =>
              handleFilterBy(selectedStartDate, selectedEndDate)
            }
            value={projectMirage}
            closeFilterModal={handleFilterModalState}
            updateRefreshToken={updateRefreshToken}
          />
        </Modal> */}
        {/* <Modal
          className={classes.projectPageModals}
          open={isSortModalOpen}
          onClose={() => setSortModalOpen(false)}
        >
          <ProjectPageSortByModal
            onSubmit={handleSubmitSort}
            defaultvalue={sortByDefault}
            closeSortModal={handleSortModalState}
            updateRefreshToken={updateRefreshToken}
          />
        </Modal> */}

        <div>
          {projectView === "active" ? (
            <Modal
              className={classes.projectPageModals}
              open={isNewActiveProjectsLoading}
            >
              <NewDataLoadingLoader trackable="Active Projects" />
            </Modal>
          ) : (
            <Modal
              className={classes.projectPageModals}
              open={isNewArchivedPageLoading}
            >
              <NewDataLoadingLoader trackable="Archived Projects" />
            </Modal>
          )}
        </div>
        <Modal
          className={classes.projectPageModals}
          open={isNewProjModalOpen}
          onClose={() => setNewProjModalOpen(false)}
        >
          <ProjectPageNewProjectModal
            type="New"
            handleClose={() => setNewProjModalOpen(false)}
            updateRefreshToken={updateRefreshToken}
            setSnackValue={setSnackValue}
            usersList={orgUsers}
            selectedTeam={selectedTeam}
            teamList={myTeams}
          />
        </Modal>
        <Modal
          className={classes.projectPageModal}
          open={editProjectModalData.isOpen}
          onClose={() =>
            setEditProjectModalData({ isOpen: false, selectedProject: {} })
          }
        >
          <ProjectPageNewProjectModal
            type="Edit"
            project={editProjectModalData.selectedProject}
            handleClose={() =>
              setEditProjectModalData({ isOpen: false, selectedProject: {} })
            }
            updateRefreshToken={updateRefreshToken}
            setSnackValue={setSnackValue}
            usersList={orgUsers}
            openDeleteProjectModal={() => {
              setDeleteProjectModalData({
                isOpen: true,
                selectedProject: editProjectModalData.selectedProject,
              });
            }}
          />
        </Modal>
        <Modal
          className={classes.projectPageModals}
          open={manageUserModal.modalOpen}
          onClose={() => setManageUserModal({ modalOpen: false, projectId: 0 })}
        >
          <ManageUsersModal
            isUpdating={isUpdating}
            handleSelectAdmin={handleSelectAdmin}
            handleSelectUser={handleSelectUser}
            projectAdmin={projectAdmin}
            projectUsers={projectUsers}
            usersList={orgUsers}
            submitManageUsersChanges={submitManageUsersChanges}
            closeModal={() =>
              setManageUserModal({ modalOpen: false, projectId: 0 })
            }
          />
        </Modal>
        <Modal
          className={classes.projectPageModal}
          open={deleteProjectModalData.isOpen}
          onClose={() =>
            setDeleteProjectModalData({ isOpen: false, selectedProject: {} })
          }
        >
          <DeleteModal
            type="Project"
            name={deleteProjectModalData?.selectedProject?.name}
            handleCloseDeleteModal={() => {
              setDeleteProjectModalData({
                isOpen: false,
                selectedProject: {},
              });
            }}
            handleDelete={handleDeleteProject}
          />
        </Modal>
        <Modal
          className={classes.projectPageModal}
          open={manageCollaboratorModalData.isOpen}
          onClose={() =>
            setManageCollaboratorModalData({
              isOpen: false,
              selectedProject: {},
            })
          }
        >
          <ManageCollaboratorModal
            selectedProject={manageCollaboratorModalData?.selectedProject}
            handleClose={() =>
              setManageCollaboratorModalData({
                isOpen: false,
                selectedProject: {},
              })
            }
          />
        </Modal>
        <Modal
          className={classes.projectPageModal}
          open={isCreateTeamModalOpen}
          onClose={() => setIsCreateTeamModalOpen(false)}
        >
          <CreateOrEditTeamModal
            handleClose={() => setIsCreateTeamModalOpen(false)}
            handleRefresh={() => {
              setRefreshCounter(refreshCounter + 1);
              setIsCreateTeamModalOpen(false);
            }}
          />
        </Modal>
      </div>
    </div>
  );
}

export default ProjectsPageOverview;

ProjectsPageOverview.propTypes = {
  projectItems: PropTypes.object,
};
